// This code has been partially generated by an AI.
import { inject } from '@angular/core';
import { API_URL } from '@app/core/services/api-token';
import { createInterceptorCondition, IncludeBearerTokenCondition } from 'keycloak-angular';

/**
 *
 * @param raw The string to escape.
 * @returns Returns the escaped string.
 * @see {@link https://github.com/toss/es-toolkit/blob/main/src/string/escapeRegExp.ts}
 */
function escapeRegExp(raw: string): string {
  return raw.replace(/[\\^$.*+?()[\]{}|]/g, String.raw`\$&`);
}

/**
 * Attach the bearer token only to requests against our own API (APIInterceptor has already prefixed API_URL).
 * @returns bearer token conditions matching API_URL
 */
export function apiUrlCondition(): IncludeBearerTokenCondition[] {
  const apiUrl = inject(API_URL);
  return [createInterceptorCondition<IncludeBearerTokenCondition>({ urlPattern: new RegExp(`^${escapeRegExp(apiUrl)}(/.*)?$`, 'i') })];
}
